<script setup lang="ts">
  import { ChevronDown, ChevronRight } from '@logistiek-zonder-papier/lzp-library'

  defineProps<{
    title: string
    open: boolean
  }>()

  const emit = defineEmits<{
    'update:open': [value: boolean]
  }>()
</script>

<template>
  <div class="accordion-item" :class="{ 'is-open': open }">
    <div class="accordion-header" @click="emit('update:open', !open)" :class="{ 'is-open': open }">
      <span class="accordion-title">{{ title }}</span>
      <ChevronDown v-if="open" />
      <ChevronRight v-else />
    </div>

    <hr v-if="open" class="accordion-divider" />

    <div
      class="accordion-body"
      :style="{
        gridTemplateRows: open ? '1fr' : '0fr',
      }"
    >
      <div class="accordion-body-inner" :class="{ 'is-open': open }">
        <slot />
      </div>
    </div>
  </div>
</template>

<style scoped lang="css">
  .accordion-divider {
    color: var(--colours-grey-5);
    border: 1px solid var(--colours-grey-5);
    margin: 0 var(--spacing-s);
  }

  .accordion-item {
    border-radius: var(--spacing-xs);
    background-color: var(--colours-grey-1);
    box-shadow: 0 1px 2px var(--colours-grey-3);
  }

  .accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0.75rem;
    cursor: pointer;
    text-align: left;
  }

  .accordion-title {
    color: var(--colours-grey-5);
  }

  .accordion-body {
    display: grid;
    grid-template-rows: 0fr;
    padding: 0;
    transition: grid-template-rows 0.2s ease;
  }

  .accordion-body-inner {
    min-height: 0;
    overflow: hidden;
    padding: var(--spacing-s);
    transition: padding 0.2s ease;
  }

  .accordion-body-inner:not(.is-open) {
    padding: 0;
  }
</style>
